/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the SubmitBountyResponseRequest interface.
 */
export function instanceOfSubmitBountyResponseRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function SubmitBountyResponseRequestFromJSON(json) {
    return SubmitBountyResponseRequestFromJSONTyped(json, false);
}
export function SubmitBountyResponseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bountyId': !exists(json, 'bountyId') ? undefined : json['bountyId'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
    };
}
export function SubmitBountyResponseRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bountyId': value.bountyId,
        'incidentReportId': value.incidentReportId,
    };
}
